import Sidebar from "../components/Sidebar";
import ChatWindow from "../components/ChatWindow/ChatWindow";
import ChatHistoryPanel from "../components/ChatHistoryPanel";
import RateCardAdministration from "../components/RateCardAdministration";
import styles from "./chatpage.module.css";
import Header from "../components/Header";
import { useMsal } from "@azure/msal-react";
import React, { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import PageLoader from "../components/PageLoader";

type Persona = "Commercial User" | "Rewards Admin";

export default function ChatBrandPage() {
  const isTablet = useMediaQuery("(max-width: 1024px)");
  const [sidebarOpen, setSidebarOpen] = useState(isTablet ? false : true);
  const [chatHistoryOpen, setChatHistoryOpen] = useState(false);

  // Persona state (only for agent 504 - Manpower Cost Calculator)
  const [selectedPersona, setSelectedPersona] =
    useState<Persona>("Commercial User");

  // store - agent is already fetched by RequireAgentAccess wrapper
  const currentAgent = useSelector(
    (state: RootState) => state.agents.currentAgent,
  );
  const agentsLoading = useSelector(
    (state: RootState) => state.agents.currentAgentLoading,
  );
  const { currentChat } = useSelector((state: RootState) => state.user);
  const user = useSelector((state: RootState) => state.auth.user);

  // Get agentId from currentAgent (as string for compatibility)
  const agentId = currentAgent?.id.toString();

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userEmail = activeAccount?.username || "Unknown User";

  // Get user's display name from MSAL account or user object
  const userName =
    activeAccount?.name ||
    user?.name ||
    user?.username ||
    activeAccount?.username?.split("@")[0] ||
    "User";

  const chatWindowColor = "#fff"; // White background

  const handleLogout = async () => {
    try {
      await instance.logoutPopup({
        postLogoutRedirectUri: "/",
      });
      window.location.href = "/";
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  const handleChatHistoryOpen = () => {
    setChatHistoryOpen(true);
  };

  const handleChatHistoryClose = () => {
    setChatHistoryOpen(false);
  };

  const handlePersonaChange = (persona: Persona) => {
    setSelectedPersona(persona);
  };

  // Show loader while agents are being fetched
  if (agentsLoading) {
    return <PageLoader label="Loading session..." activeNav="home" />;
  }

  // Check if there are any messages to change background color
  const hasMessages = currentChat && currentChat.length > 0;

  // Check if RFQ Builder is active
  const isRfqBuilder =
    agentId === "45" ||
    currentChat.some((msg) => msg.agentIdName === "rfq_builder");

  return (
    <>
      <div
        className={styles.chatpageContainer}
        style={{
          backgroundColor: "#ffffff",
        }}
      >
        <Sidebar
          activeNav="home"
          user={user || undefined}
          onLogout={handleLogout}
          showChatHistory={true}
          onChatHistoryClick={handleChatHistoryOpen}
          isChatHistoryOpen={chatHistoryOpen}
        />
        <div className={styles.mainContent}>
          {/* Hide header for RFQ Builder */}
          {!isRfqBuilder && (
            <Header
              isSidebarOpen={() => setSidebarOpen(!sidebarOpen)}
              currentAgent={currentAgent}
              selectedPersona={selectedPersona}
              onPersonaChange={handlePersonaChange}
              userName={userName}
            />
          )}
          {currentAgent?.is_man_power_admin === 1 &&
          currentAgent?.id === 504 &&
          selectedPersona === "Rewards Admin" ? (
            <RateCardAdministration />
          ) : (
            <ChatWindow
              currentAgent={currentAgent}
              agentId={agentId}
              chatWindowColor={chatWindowColor}
            />
          )}
        </div>
      </div>
      <ChatHistoryPanel
        isOpen={chatHistoryOpen}
        onClose={handleChatHistoryClose}
        agentName={currentAgent?.agent_name || ""}
      />
    </>
  );
}
